import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        outline: 'text-foreground',
        /** Brand-tinted attribute badge (e.g. "Public") — never a runtime state. */
        brand: 'border-primary/30 bg-primary/10 text-primary',
        /** Status tints — the only way runtime state is colored in the portal. */
        success: 'border-success-border bg-success-subtle text-success-emphasis',
        warning: 'border-warning-border bg-warning-subtle text-warning-emphasis',
        info: 'border-info-border bg-info-subtle text-info-emphasis',
        destructive: 'border-destructive-border bg-destructive-subtle text-destructive-emphasis',
        muted: 'border-border bg-muted text-muted-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
